import { useMemo } from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import {
  auth0Domain,
  auth0ClientId,
  auth0Audience,
  auth0RedirectUri,
} from "../config/auth0Config";
import AuthTokenBridge from "./AuthTokenBridge";

// Auth0 ke critical env vars validate karne ke liye helper flag
const missingConfig =
  !auth0Domain?.length || !auth0ClientId?.length || !auth0RedirectUri?.length;

const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  // Memoized authorization params taa-ke har render par nai object create na ho
  const authorizationParams = useMemo(() => {
    const params = {
      redirect_uri: auth0RedirectUri,
      scope: "openid profile email",
    };

    if (auth0Audience) {
      params.audience = auth0Audience;
    }

    return params;
  }, [auth0Audience, auth0RedirectUri]);

  // Auth0 callback ke baad user ko desired route pe redirect karne ka handler
  const onRedirectCallback = (appState) => {
    const targetRoute = appState?.returnTo || "/dashboard";
    navigate(targetRoute, { replace: true });
  };

  if (missingConfig) {
    throw new Error(
      "Missing Auth0 configuration. Please set the Auth0 environment variables."
    );
  }

  return (
    // Auth0Provider ke andar AuthTokenBridge rakha gaya hai for token syncing
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      authorizationParams={authorizationParams}
      cacheLocation="localstorage"
      useRefreshTokens
      useRefreshTokensFallback
      onRedirectCallback={onRedirectCallback}
    >
      <AuthTokenBridge>{children}</AuthTokenBridge>
    </Auth0Provider>
  );
};

export default AuthProvider;